import { useState, useRef, useCallback } from 'react';
import { ChevronsUpDown } from 'lucide-react';

export default function BeforeAfterSlider({
  beforeSrc,
  afterSrc,
  beforeLabel = 'Før',
  afterLabel = 'Etter',
  height = 400,
}) {
  const [splitY, setSplitY] = useState(50);
  const [dragging, setDragging] = useState(false);
  const containerRef = useRef(null);

  const getY = (clientY) => {
    const rect = containerRef.current.getBoundingClientRect();
    const y = ((clientY - rect.top) / rect.height) * 100;
    return Math.min(Math.max(y, 5), 95);
  };

  const onMove = useCallback((clientY) => {
    if (!dragging) return;
    setSplitY(getY(clientY));
  }, [dragging]);

  const onMouseMove = (e) => onMove(e.clientY);
  const onTouchMove = (e) => onMove(e.touches[0].clientY);

  return (
    <div
      ref={containerRef}
      className="relative overflow-hidden rounded-[8px] cursor-ns-resize select-none"
      style={{ height }}
      onMouseMove={onMouseMove}
      onMouseUp={() => setDragging(false)}
      onMouseLeave={() => setDragging(false)}
      onTouchMove={onTouchMove}
      onTouchEnd={() => setDragging(false)}
    >
      {/* BEFORE (top) */}
      <div className="absolute inset-0">
        <img src={beforeSrc} alt={beforeLabel} className="w-full h-full object-cover" draggable={false} />
        <span className="absolute top-4 left-4 font-body text-xs tracking-widest uppercase text-white bg-black/40 px-3 py-1 rounded-full backdrop-blur-sm">
          {beforeLabel}
        </span>
      </div>

      {/* AFTER (bottom — clipped) */}
      <div
        className="absolute inset-0 overflow-hidden"
        style={{ clipPath: `inset(${splitY}% 0 0 0)` }}
      >
        <img src={afterSrc} alt={afterLabel} className="w-full h-full object-cover" draggable={false} />
        <span className="absolute bottom-4 left-4 font-body text-xs tracking-widest uppercase text-white bg-black/40 px-3 py-1 rounded-full backdrop-blur-sm">
          {afterLabel}
        </span>
      </div>

      {/* DIVIDER LINE */}
      <div
        className="absolute left-0 right-0 pointer-events-none"
        style={{ top: `${splitY}%` }}
      >
        <div className="h-[2px] bg-white/70 w-full" />
      </div>

      {/* HANDLE */}
      <div
        className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center cursor-ns-resize"
        style={{ top: `${splitY}%` }}
        onMouseDown={(e) => { e.preventDefault(); setDragging(true); }}
        onTouchStart={(e) => { e.preventDefault(); setDragging(true); }}
      >
        <ChevronsUpDown size={18} className="text-[#2a1810]" />
      </div>
    </div>
  );
}